import $axios from "@/plugins/axios";

/*
  设置默认地址
  @param {Object} params
*/ 
export const setDfaultAddress = params => $axios(
  {
    url: "/v1/address/set_default",
    data: params,
    method: 'POST',
  },
  {
    code_message_show: true,
  }
);
/*
  删除地址
  @param {Object} params
*/ 
export const removeAddress = params => $axios(
  {
    url: "/v1/address/del",
    data: params,
    method: 'POST',
  },
  {
    code_message_show: true,
  }
);
/*
  查询默认地址
  @param {Object} params
*/ 
export const queryDefaultAddress = params => $axios(
  {
    url: "/v1/address/get_default",
    params,
    method: 'GET',
  },
  {
    code_message_show: true,
  }
);
/*
  收货地址列表
  @param {Object} params
*/ 
export const queryAddressList = params => $axios(
  {
    url: "/v1/address/lists",
    params,
    method: 'GET',
  },
  {
    code_message_show: true,
  }
);
/*
  添加收货地址
  @param {Object} params
*/ 
export const addNewAddress = params => $axios(
  {
    url: "/v1/address/add",
    data: params,
    method: 'POST',
  },
  {
    code_message_show: true,
  }
);
/*
  编辑收货地址
  @param {Object} params
*/ 
export const editAddress = params => $axios(
  {
    url: "/v1/address/edit",
    data: params,
    method: 'POST',
  },
  {
    code_message_show: true,
  }
);
/*
  省
  @param {Object} params
*/ 
export const queryProvinceList = params => $axios(
  {
    url: "/v1/address/all_province",
    params,
    method: 'GET',
  },
  {
    code_message_show: true,
  }
);
/*
  市
  @param {Object} params
*/ 
export const queryCityList = params => $axios(
  {
    url: "/v1/address/all_city",
    params,
    method: 'GET',
  },
  {
    code_message_show: true,
  }
);
/*
  区
  @param {Object} params
*/ 
export const queryAreaList = params => $axios(
  {
    url: "/v1/address/all_area",
    params,
    method: 'GET',
  },
  {
    code_message_show: true,
  }
);